<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Uredite tip davka {{ taxType.name }}:
    </h2>

    <TaxTypeForm
      @save="save"
      @cancel="cancel"
      :taxType="taxType"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { loadItem, saveItem } from '@/utils/crudFunctions'
import TaxTypeForm from '@/components/TaxTypeForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'

export default {
  components: {
    TaxTypeForm
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    id: {
      required: true,
      type: Number
    }
  },
  computed: {
    taxType () {
      return this.$store.state.taxTypes.items[this.id]
    }
  },
  methods: {
    ...mapActions('taxTypes', ['loadItem', 'saveItem']),
    save ({ data }) {
      saveItem(data, 'MyCompanyTaxTypes', this)
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyTaxTypes' })
    }
  },
  created () {
    loadItem(this)
  }
}
</script>
